import modalTemplateURL from 'ngtemplate-loader!./alertModal.tpl.html';

const name = 'giftAlertModal'

export const template = modalTemplateURL;
export default class alertModal {

  constructor($modalInstance, gift, formClass) {
    angular.extend(this, $modalInstance);
    this.gift = angular.extend({}, gift);
    this.form = formClass;
    this._tab = 'discount';
    this._errors = [];
  }

  cleanName(name) {
    return name.split('.').map((n) => {
      n = n.charAt(0).toUpperCase() + n.substring(1);
      return n;
    }).join(' ')
  }

  activeTab(tab) {
    return this._tab === tab;
  }

  get errors() {
    return this.form.form.$error;
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  };


}


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/gifts/alertModal.js